module.exports = __webpack_public_path__ + "static/assets/ee5d701b55c108bbaabde0cb414526a9.gif";